import { MainInput } from '../../Components/UI/Input';

import { Select } from '../../Components/UI/Select';
import { RoundRadio } from '../../Components/UI/Radio';

import { useSelector } from 'react-redux';
import { getAllUsersData } from '../../Redux/Selectors/AllUsersSelectors';
import { filterOptions } from '../ObjectCategoriesConfig';
import { constants } from '../../Configs/constants';

const { CATEGORIES, ROOM_TYPES } = constants;

const roomVariants = Object.values(ROOM_TYPES).reduce(
  (acc, { index, name }) => {
    acc[index] = name;
    return acc;
  },
  {},
);

export const loginFormConfig = {
  title: 'Užpildykite formą',
  elements: [
    {
      Element: MainInput,
      options: {
        name: 'email',
        type: 'email',
        label: 'Paštą',
        placehold: 'paštą',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 3) return 1;
        },
        errors: ['Must not be empty', 'Must be longer then 3 symbol'],
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'password',
        type: 'password',
        label: 'Slaptažodis',
        placehold: 'slaptažodis',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 8) return 1;
        },
        errors: ['Must not be empty', 'Must be longer then 8 symbol'],
      },
    },
  ],
  button: {
    text: 'Prisijungti',
  },
};

export const careerFormConfig = {
  title: 'Užpildykite formą',
  elements: [
    {
      Element: MainInput,
      options: {
        name: 'name',
        type: 'text',
        label: 'Vardas',
        placehold: 'Įveskite savo vardą',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 4) return 1;
          if (!/^[A-Z][a-z]+(\s[A-Z][a-z]+)?$/.test(val)) return 2;
        },
        errors: [
          'Must not be empty',
          'Must be longer then 4 symbol',
          'Raimond Pauls',
        ],
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'email',
        type: 'email',
        label: 'E-mail',
        placehold: 'info@gmail.com',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 8) return 1;
        },
        errors: ['Must not be empty', 'Must be longer then 8 symbol'],
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'phone',
        type: 'tel',
        label: 'Jūsų tel. numeris',
        placehold: '+ 370 000 00000',
        validator: val => {
          if (!val.length) return 0;
          if (!/^\+/.test(val)) return 1;
          if (!/^\+\d+$/.test(val)) return 2;
          if (val.length < 12) return 3;
        },
        errors: [
          'Must not be empty',
          'Must start with +',
          'Must contain only + and digits',
          'Must be at least 11 symbols long',
        ],
      },
    },
    {
      Element: MainInput,
      options: {
        element: 'textarea',
        name: 'comment',
        type: '',
        label: 'Papildoma informacija',
        placehold: 'Pakomentuoti komentarus',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 8) return 1;
        },
        errors: ['Must not be empty', 'Must be longer then 8 symbol'],
      },
    },
  ],
  button: {
    text: 'Siųsti',
  },
};

export const profileFormConfig = {
  title: '',
  elements: [
    {
      Element: MainInput,
      options: {
        name: 'name',
        type: 'text',
        label: 'Vardas',
        placehold: 'Įveskite savo vardą',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 4) return 1;
          if (!/^[A-Z][a-z]+(\s[A-Z][a-z]+)?$/.test(val)) return 2;
        },
        errors: [
          'Must not be empty',
          'Must be longer then 4 symbol',
          'Raimond Pauls',
        ],
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'email',
        type: 'email',
        label: 'E-mail',
        placehold: 'info@gmail.com',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 8) return 1;
        },
        errors: ['Must not be empty', 'Must be longer then 8 symbol'],
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'phone',
        type: 'tel',
        label: 'Jūsų tel. numeris',
        placehold: '+ 370 000 00000',
        validator: val => {
          if (!val.length) return 0;
          if (!/^\+/.test(val)) return 1;
          if (!/^\+\d+$/.test(val)) return 2;
          if (val.length < 12) return 3;
        },
        errors: [
          'Must not be empty',
          'Must start with +',
          'Must contain only + and digits',
          'Must be at least 11 symbols long',
        ],
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'whatsup',
        type: 'tel',
        label: 'Jūsų whatsup numeris',
        placehold: '370 000 00000',
        validator: val => {
          if (!/^\d*$/.test(val)) return 0;
          if (val.length > 0 && val.length < 11) return 1;
        },
        errors: [
          'Must contain only digits',
          'Must be at least 11 symbols long',
        ],
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'viber',
        type: 'tel',
        label: 'Jūsų viber numeris',
        placehold: '370 000 00000',
        validator: val => {
          if (!/^\d*$/.test(val)) return 0;
          if (val.length > 0 && val.length < 11) return 1;
        },
        errors: [
          'Must contain only digits',
          'Must be at least 11 symbols long',
        ],
      },
    },
    {
      Element: MainInput,
      options: {
        element: 'textarea',
        name: 'about',
        type: '',
        label: 'Papildoma informacija',
        placehold: 'Pakomentuoti komentarus',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 8) return 1;
        },
        errors: ['Must not be empty', 'Must be longer then 8 symbol'],
      },
    },
  ],
  button: {
    text: 'pasilikti',
    inactiveText: 'redaguoti',
    wd: '180px',
    containerStyle: {
      textAlign: 'end',
    },
  },
};

export const profileBrokerFormConfig = {
  title: '',
  elements: [
    {
      Element: MainInput,
      options: {
        name: 'name',
        type: 'text',
        label: 'Vardas',
        placehold: 'Įveskite savo vardą',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 4) return 1;
          if (!/^[A-Z][a-z]+(\s[A-Z][a-z]+)?$/.test(val)) return 2;
        },
        errors: [
          'Must not be empty',
          'Must be longer then 4 symbol',
          'Raimond Pauls',
        ],
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'email',
        type: 'email',
        label: 'E-mail',
        placehold: 'info@gmail.com',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 8) return 1;
        },
        errors: ['Must not be empty', 'Must be longer then 8 symbol'],
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'phone',
        type: 'tel',
        label: 'Jūsų tel. numeris',
        placehold: '+ 370 000 00000',
        validator: val => {
          if (!val.length) return 0;
          if (!/^\+/.test(val)) return 1;
          if (!/^\+\d+$/.test(val)) return 2;
          if (val.length < 12) return 3;
        },
        errors: [
          'Must not be empty',
          'Must start with +',
          'Must contain only + and digits',
          'Must be at least 11 symbols long',
        ],
      },
    },
    {
      Element: MainInput,
      options: {
        element: 'textarea',
        name: 'about',
        type: '',
        label: 'Papildoma informacija',
        placehold: 'Pakomentuoti komentarus',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 8) return 1;
        },
        errors: ['Must not be empty', 'Must be longer then 8 symbol'],
      },
    },
  ],
  button: {
    text: 'pasilikti',
    inactiveText: 'redaguoti',
  },
};

export const inviteFormConfig = {
  title: 'Pridėti brokerį',
  elements: [
    {
      Element: MainInput,
      options: {
        name: 'email',
        type: 'email',
        label: 'E-mail',
        placehold: 'info@gmail.com',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 8) return 1;
        },
        errors: ['Must not be empty', 'Must be longer then 8 symbol'],
      },
    },
  ],
  closeButton: true,
  button: {
    text: 'Siųsti',
  },
};

export const confirmFormConfigs = [
  {
    title: 'Patvirtinti brokerio pašalinimą',
    closeButton: true,
    button: {
      text: 'patvirtinti',
      butType: 'red',
    },
  },
  {
    title: 'Patvirtinti siųsti nauja slaptažodį',
    closeButton: true,
    button: {
      text: 'patvirtinti',
    },
  },
];

export const confirmPartnersConfigs = [
  {
    title: 'Patvirtinti pašalinti partnerį',
    closeButton: true,
    button: {
      text: 'patvirtinti',
      butType: 'red',
    },
  },
  {
    title: 'Patvirtinti paslėpti partnerį',
    closeButton: true,
    button: {
      text: 'patvirtinti',
    },
  },
];

export const confirmLogoutConfigs = {
  title: 'Patvirtinti atsijungti',
  closeButton: true,
  button: {
    text: 'patvirtinti',
    butType: 'red',
  },
};

export const confirmLCareerItemConfigs = {
  title: 'Patvirtinti ištrinti',
  closeButton: true,
  button: {
    text: 'patvirtinti',
    butType: 'red',
  },
};

export const roomFormConfig = {
  title: 'Izvēlieties telpas',
  elements: [
    {
      Element: Select,
      options: {
        name: 'type',
        label: 'Izvēlieties telpas tipu',
        options: roomVariants,
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'square',
        type: 'text',
        label: 'Plotas',
        placehold: '0',
        regE: '\\d',
        validator: val => {
          if (!val.length) return 0;
        },
        errors: ['Must not be empty'],
      },
    },
  ],
  button: {
    text: 'patvirtinti',
  },
};

export const clientFormConfig = {
  title: '',
  allowPatch: true,
  elements: [
    {
      Element: MainInput,
      options: {
        name: 'name',
        type: 'text',
        label: 'Vardas',
        placehold: 'Vardas',
        validator: val => {
          if (!val.length) return 0;
        },
        errors: ['Must not be empty'],
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'phone',
        type: 'tel',
        label: 'tel. numeris',
        placehold: '+370 000 00000',
        validator: val => {
          if (!val.length) return 0;
          if (!/^\+/.test(val)) return 1;
          if (!/^\+\d+$/.test(val)) return 2;
          if (val.length < 12) return 3;
        },
        errors: [
          'Must not be empty',
          'Must start with +',
          'Must contain only + and digits',
          'Must be at least 11 symbols long',
        ],
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'email',
        type: 'email',
        label: 'el. paštas',
        placehold: 'info@gmail.com',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 8) return 1;
        },
        errors: ['Must not be empty', 'Must be longer then 8 symbol'],
      },
    },
  ],
  button: {
    text: 'patvirtinti',
  },
};

export const deleteRoomConfig = {
  title: 'Patvirtinti ištrinti',
  closeButton: true,
  button: {
    text: 'patvirtinti',
    butType: 'red',
  },
};

export const careerAdminFormConfig = {
  title: '',
  elements: [
    {
      Element: MainInput,
      options: {
        name: 'title',
        type: 'text',
        label: 'Laisva vieta',
        placehold: 'Įveskite laisva vieta',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 8) return 1;
        },
        errors: ['Must not be empty', 'Must be longer then 4 symbol'],
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'description',
        element: 'textarea',
        type: 'text',
        label: 'Apibūdinimas',
        placehold: 'Įveskite apibūdinimas',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 8) return 1;
        },
        errors: ['Must not be empty', 'Must be longer then 4 symbol'],
      },
    },
    {
      Element: Select,
      options: {
        name: 'experience',
        label: 'Reikalinga patirtis',
        options: [
          'Visi variantai',
          '0.5 - 1',
          '1',
          '1 - 2',
          '1 - 3',
          '2',
          '3',
          '3+',
        ],
      },
    },
    {
      Element: Select,
      options: {
        name: 'type',
        label: 'Darbo diena',
        options: ['Visi variantai', 'Pilnas laikas', 'Ne pilnas laikas'],
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'duties',
        element: 'textarea',
        type: 'text',
        label: 'Atsakomybė',
        placehold: 'Įveskite atsakomybė',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 8) return 1;
        },
        errors: ['Must not be empty', 'Must be longer then 4 symbol'],
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'requirements',
        element: 'textarea',
        type: 'text',
        label: 'Reikalavimai',
        placehold: 'Įveskite reikalavimai',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 8) return 1;
        },
        errors: ['Must not be empty', 'Must be longer then 4 symbol'],
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'conditions',
        element: 'textarea',
        type: 'text',
        label: 'Sąlygos',
        placehold: 'Įveskite sąlygos',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 8) return 1;
        },
        errors: ['Must not be empty', 'Must be longer then 4 symbol'],
      },
    },
    {
      Element: Select,
      options: {
        name: 'broker',
        label: 'Broker',
        setOptions: {
          fn: useSelector,
          params: [getAllUsersData],
          transform: users =>
            users.reduce((acc, { _id, name }) => {
              acc[_id] = name;
              return acc;
            }, {}),
        },
      },
    },
  ],
  button: {
    text: 'pasilikti',
    inactiveText: 'redaguoti',
    wd: '180px',
    containerStyle: {
      textAlign: 'end',
    },
  },
};

export const careerAdminCreateFormConfig = {
  title: '',
  elements: [
    {
      Element: MainInput,
      options: {
        name: 'title',
        type: 'text',
        label: 'Laisva vieta',
        placehold: 'Įveskite laisva vieta',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 8) return 1;
        },
        errors: ['Must not be empty', 'Must be longer then 4 symbol'],
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'description',
        element: 'textarea',
        type: 'text',
        label: 'Apibūdinimas',
        placehold: 'Įveskite apibūdinimas',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 8) return 1;
        },
        errors: ['Must not be empty', 'Must be longer then 4 symbol'],
      },
    },
    {
      Element: Select,
      options: {
        name: 'experience',
        label: 'Reikalinga patirtis',
        options: ['0.5 - 1', '1', '1 - 2', '1 - 3', '2', '3', '3+'],
      },
    },
    {
      Element: Select,
      options: {
        name: 'type',
        label: 'Darbo diena',
        options: ['Pilnas laikas', 'Ne pilnas laikas'],
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'duties',
        element: 'textarea',
        type: 'text',
        label: 'Atsakomybė',
        placehold: 'Įveskite atsakomybė',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 8) return 1;
        },
        errors: ['Must not be empty', 'Must be longer then 4 symbol'],
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'requirements',
        element: 'textarea',
        type: 'text',
        label: 'Reikalavimai',
        placehold: 'Įveskite reikalavimai',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 8) return 1;
        },
        errors: ['Must not be empty', 'Must be longer then 4 symbol'],
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'conditions',
        element: 'textarea',
        type: 'text',
        label: 'Sąlygos',
        placehold: 'Įveskite sąlygos',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 8) return 1;
        },
        errors: ['Must not be empty', 'Must be longer then 4 symbol'],
      },
    },
    {
      Element: Select,
      options: {
        name: 'broker',
        label: 'Broker',
        setOptions: {
          fn: useSelector,
          params: [getAllUsersData],
          transform: users =>
            users.reduce((acc, { _id, name }) => {
              acc[_id] = name;
              return acc;
            }, {}),
        },
      },
    },
  ],
  button: {
    text: 'Pridėti',
    wd: '180px',
    containerStyle: {
      textAlign: 'end',
    },
  },
};

export const geoFormConfig = {
  elements: [
    {
      Element: MainInput,
      options: {
        name: 'name',
        type: 'text',
        label: 'Pavadinimas',
        placehold: 'Įveskite pavadinimas',
        validator: val => {
          if (!val.length) return 0;
          if (!/^[A-Z]/.test(val)) return 1;
          if (val.length < 3) return 2;
        },
        errors: [
          'Must not be empty',
          'Must start with capital letter',
          'Must be longer then 3 symbol',
        ],
      },
    },
  ],
  button: {
    text: 'taikyti',
  },
};

export const advertFormConfig = {
  title: '',
  elements: [
    {
      Element: MainInput,
      options: {
        name: 'name',
        type: 'text',
        label: '*Jūsų vardas',
        placehold: 'vardas',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 3) return 1;
          if (!/^[A-Z]/.test(val)) return 2;
          if (!/^[A-Z][a-z]+(\s[A-Z][a-z]+)?$/.test(val)) return 3;
        },
        errors: [
          'Must not be empty',
          'Must be longer then 3 symbol',
          'Must start with capital letter',
          'Example: Raimond Pauls',
        ],
      },
    },
    {
      Element: RoundRadio,
      options: {
        name: 'type',
        variants: ['Pirkti', 'Parduoti'],
        label: 'Noriu',
      },
    },
    {
      Element: Select,
      options: {
        name: 'category',
        options: CATEGORIES.map(({ name }) => name || 'Visi variantai'),
        label: '*Objekto tipas',
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'phone',
        type: 'tel',
        label: '*Jūsų tel. numeris',
        placehold: '+370 000 00000',
        validator: val => {
          if (!val.length) return 0;
          if (!/^\+/.test(val)) return 1;
          if (!/^\+\d+$/.test(val)) return 2;
          if (val.length < 12) return 3;
        },
        errors: [
          'Must not be empty',
          'Must start with +',
          'Must contain only + and digits',
          'Must be at least 11 symbols long',
        ],
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'email',
        type: 'email',
        label: '*Jūsų el. paštas',
        placehold: 'info@gmail.com',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 8) return 1;
        },
        errors: ['Must not be empty', 'Must be longer then 8 symbol'],
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'text',
        element: 'textarea',
        type: 'text',
        label: '*Papildoma informacija',
        placehold: 'informacija',
        validator: val => {
          if (!val.length) return 0;
          if (val.length < 8) return 1;
        },
        errors: ['Must not be empty', 'Must be longer then 8 symbol'],
      },
    },
  ],
  button: {
    text: 'Siųsti',
  },
};

export const createObjectFormConfig = {
  title: 'sukurti objektą',
  elements: [
    {
      Element: Select,
      options: {
        name: 'category',
        label: 'Objekto tipas',
        options: filterOptions.category,
      },
    },
    {
      Element: Select,
      options: {
        name: 'type',
        label: 'Parduodama ar nuomojama',
        options: filterOptions.type,
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'address',
        type: 'text',
        label: 'Adresu',
        placehold: 'adresu',
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'title',
        type: 'text',
        label: 'Aapibūdinimas',
        placehold: 'apibūdinimas',
      },
    },
    {
      Element: MainInput,
      options: {
        name: 'price',
        element: 'textarea',
        type: 'text',
        label: 'Kaina',
        placehold: 'kaina',
      },
    },
    {
      Element: Select,
      options: {
        name: 'broker',
        label: 'Broker',
        setOptions: {
          fn: useSelector,
          params: [getAllUsersData],
          transform: users =>
            users.reduce((acc, { _id, name }) => {
              acc[_id] = name;
              return acc;
            }, {}),
        },
      },
    },
  ],
  button: {
    text: 'sukurti',
  },
};
